import {Component, OnDestroy, OnInit} from '@angular/core';
import {Conclusion} from '@namespaces/conclusion.namespace';
import {ActivatedRoute, Router} from '@angular/router';
import {EventsService} from '@services/events.service';
import {ConclusionApiService} from '@api/conclusion.api.service';
import {UserNamespace} from '@namespaces/user.namespace';
import {RoutesStorage} from '@helpers/routes.helper';
import {AjaxDownloadQueueItem, AjaxDownloadService} from '@components/ajax-download-noty/ajax-download.service';
import {MimeTypeNamespace} from '@namespaces/mime-type.namespace';

@Component({
    selector: 'app-conclusion-view',
    templateUrl: 'conclusion-view.component.html'
})

export class ConclusionViewComponent implements OnInit, OnDestroy {

    conclusion: Conclusion.ViewData;

    permissions = UserNamespace.Permission;

    objectUrl: string;

    deviceUrl: string;

    downloadUrl: string;

    editUrl: string;

    listUrl = RoutesStorage.Conclusion.list;

    documentDownloadQueue$: AjaxDownloadQueueItem;

    documentImageUrl = MimeTypeNamespace.getMimeImageUrl(MimeTypeNamespace.MimeEnums.officeDOCX);

    constructor(
        private api: ConclusionApiService,
        private router: Router,
        private route: ActivatedRoute,
        private events: EventsService,
        private ajaxDownloadService: AjaxDownloadService,
    ) {
    }

    ngOnInit() {
        this.conclusion = this.route.snapshot.data.conclusionView;

        if (this.conclusion) {
            const objectId = this.conclusion.working_object && this.conclusion.working_object.id;
            const deviceId = this.conclusion.technical_device && this.conclusion.technical_device.id;

            this.downloadUrl = this.api.getDocumentGeneratePath(this.conclusion.id);

            this.objectUrl = RoutesStorage.WorkingObject.view(objectId);
            this.deviceUrl = RoutesStorage.TechnicalDevice.view(deviceId);

            this.editUrl = RoutesStorage.Conclusion.edit(
                this.conclusion.id,
                this.conclusion.technical_device_element.id,
                this.conclusion.technical_card.id
            );
        }
    }

    remove() {
        if (!this.conclusion) {
            return;
        }

        this.events.showConfirm({
            title: 'Вы уверены, что хотите удалить заключение?',
            confirmButtonTitle: 'Удалить',
        }).subscribe(() => {
            this.api.delete({
                id: this.conclusion.id
            }).subscribe(() => {
                this.redirectToList();
            }, () => {

            });
        }, () => {});
    }

    download() {
        this.documentDownloadQueue$ = this.ajaxDownloadService.do({
            url: this.downloadUrl,
            currentQueue: this.documentDownloadQueue$,
            taskName: 'Заключение',
        });
    }

    redirectToList() {
        this.router.navigate([this.deviceUrl]);
    }

    ngOnDestroy(): void {
        if (this.documentDownloadQueue$) {
            this.documentDownloadQueue$.complete();
        }
    }
}
